import { defineComponent, onMounted, onUnmounted } from 'vue';
import { MultiSelect } from '@studyportals/multiselect';
import LoadingWrapper from '@/presentation/components/shared/loading-wrapper/loading-wrapper.vue';
import CampaignTypeCode from '@/presentation/components/campaign-settings/campaign-type/campaign-type.code';

export default defineComponent({
	components: {
		LoadingWrapper,
		MultiSelect
	},
	setup: () => {
		const code = new CampaignTypeCode();

		onMounted(code.mounted.bind(code));
		onUnmounted(code.unmounted.bind(code));

		return {
			campaignTypeDropdown: code.campaignTypeDropdown,
			options: code.options,
			isLoading: code.isLoading,
			isFieldValidatedAndMissing: code.isFieldValidatedAndMissing,
			nameOfSelectedCampaignType: code.nameOfSelectedCampaignType,
			isCampaignCreation: code.isCampaignCreation,
			isCampaignTypeCustomProductsOnly: code.isCampaignTypeCustomProductsOnly,
			setCampaignType: code.setCampaignType.bind(code)
		};
	}
});
